module.exports = __webpack_public_path__ + "img/growth-banner-bg.4d4f3b81.svg";